<template>
  <div class="navbar navbar-dark bg-teal border-top py-1">
    <div class="container-fluid justify-content-start">
      <ul class="nav">
        <li class="nav-item" title="Voltar">
          <router-link to="/home" class="navbar-nav-link-icon ps-0">
            <span class="badge bg-yellow text-black">Voltar</span>
          </router-link>
        </li>
      </ul>
      <span class="navbar-text">
        | {{ centroCustoPai.codCCustoPai }} - {{ centroCustoPai.nomeCCustoPai }}
      </span>
      <form class="ms-auto">
        <select
          class="form-select wmin-xl-200"
          @change="alterarOrcamentoSelecionado"
        >
          <option
            v-for="orcamento in orcamentos"
            :key="orcamento.id"
            :value="orcamento.id"
            :selected="orcamento.id == orcamentoSelecionado.id"
          >
            {{ orcamento.ano }}
          </option>
        </select>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PATHS from '@/router/routesMap'

export default {
  name: 'NavbarSecondary',

  data() {
    return {
      codCCustoPai: this.$route.params.codCCustoPai,
      centroCustoPai: {},
      orcamentos: [],
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),
  },

  methods: {
    async getCentroCustoPai() {
      try {
        this.centroCustoPai = await this.$store.dispatch(
          'getCentroCustoPai',
          this.codCCustoPai,
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },

    async getOrcamentos() {
      try {
        this.orcamentos = await this.$store.dispatch('getOrcamentos')

        const orcamentoAtivo = this.orcamentos.find(
          (orcamento) => orcamento.ativo === '1',
        )
        this.$store.dispatch('setOrcamentoSelecionado', orcamentoAtivo)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    alterarOrcamentoSelecionado(event) {
      const orcamentoSelecionado = this.orcamentos.find(
        (orcamento) => orcamento.id === event.target.value,
      )
      this.$store.dispatch('setOrcamentoSelecionado', orcamentoSelecionado)
    },
  },

  mounted() {
    this.getCentroCustoPai()
    this.getOrcamentos()
  },
}
</script>
